import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const FillterButton = () => {
  const navigate = useNavigate();

  const buttonData = [
    {
      name: '경매신건',
      imgSrc: '/assets/images/icon/icon_newauction.svg',
      onClick: () => {
        navigate('/NewAuction');
      },
    },
    // {
    //   name: '예정물건',
    //   imgSrc: '/assets/images/icon/icon_expected.svg',
    //   onClick: () => {
    //     // navigate('/scheduledAuction');
    //   },
    // },
    {
      name: '최근2주변동',
      name1: '최근2주',
      name2: '변동물건',
      imgSrc: '/assets/images/icon/icon_change.svg',
      onClick: () => {
        navigate('/search?type=c&specialCondition=최근 2주 변동 물건');
      },
    },
    {
      name: '공시1억이하',
      name1: '공시가격',
      name2: '1억이하',
      imgSrc: '/assets/images/icon/icon_below.svg',
      onClick: () => {
        navigate('/search?type=c&specialCondition=공시가격 1억 이하');
      },
    },
    {
      name: 'HUG인수조건변경',
      name1: 'HUG',
      name2: '인수조건변경',
      imgSrc: '/assets/images/icon/icon_conditions.png',
      onClick: () => {
        navigate('/search?type=c&specialCondition=HUG 임차권 인수조건 변경');
      },
    },
    {
      name: '지분경매',
      name1: '지분',
      name2: '경매물건',
      imgSrc: '/assets/images/icon/icon_share.svg',
      onClick: () => {
        navigate('/search?type=c&specialCondition=지분입찰 물건');
      },
    },
    {
      name: '법정지상권',
      name1: '법정',
      name2: '지상권물건',
      imgSrc: '/assets/images/icon/icon_statutory.svg',
      onClick: () => {
        navigate('/search?type=c&specialCondition=법정지상권');
      },
    },
    {
      name: '유치권',
      imgSrc: '/assets/images/icon/icon_lien.svg',
      onClick: () => {
        navigate('/search?type=c&specialCondition=유치권');
      },
    },
    {
      name: '감정1년후',
      name1: '감정',
      name2: '1년후물건',
      imgSrc: '/assets/images/icon/icon_year.svg',
      onClick: () => {
        navigate('/search?type=c&specialCondition=감정시점 1년 경과 물건');
      },
    },
    {
      name: '반값경매',
      imgSrc: '/assets/images/icon/icon_auctionsale.svg',
      onClick: () => {
        navigate('/search?type=c&specialCondition=반값 경매물건');
      },
    },
    {
      name: '반값공매',
      imgSrc: '/assets/images/icon/icon_publicsale.svg',
      onClick: () => {
        navigate('/search?type=c&specialCondition=반값 공매물건&type=p');
      },
    },
    {
      name: '반값NPL',
      imgSrc: '/assets/images/icon/icon_nplsale.svg',
      onClick: () => {
        navigate('search?type=c&specialCondition=반값 NPL물건');
      },
    },
    {
      name: ' ',
      imgSrc: '',
      // onClick: () => {
      //   navigate('search?type=c&specialCondition=반값 NPL물건');
      // },
    },
  ];

  const handleNotAvailable = (name: string) => {
    if (name === '예정물건') {
      return true;
    }
    return false;
  };

  const chunkArray = (array: any[], size: number) => {
    return Array.from({ length: Math.ceil(array.length / size) }, (_, i) =>
      array.slice(i * size, i * size + size),
    );
  };

  const chunkedButtons = chunkArray(buttonData, 4);
  return (
    <FilterButtonContainer>
      <Inner>
        <>
          {chunkedButtons.map((group, index) => (
            <ButtonWrapper key={index}>
              {group.map((button) => (
                <Button
                  key={button.name}
                  onClick={button.onClick}
                  style={{ opacity: handleNotAvailable(button.name) ? 0.2 : 1 }}
                >
                  {button.imgSrc && <img src={button.imgSrc} alt="" />}
                  {/* {button.name1 ? (
                    <div>
                      <div>{button.name1}</div>
                      <div>{button.name2}</div>
                    </div>
                  ) : ( */}
                    <div>{button.name}</div>
                  {/* )} */}
                </Button>
              ))}
            </ButtonWrapper>
          ))}
        </>
      </Inner>
    </FilterButtonContainer>
  );
};

export default FillterButton;

const Button = styled.div`
  width: 82px;
  display: flex;
  flex-direction: column;

  align-items: center;
  gap: 4px;
  cursor: pointer;
  img {
    width: 32px;
    height: 32px;
  }
  div {
    text-align: center;
    white-space: wrap;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
`;
const Inner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  height: 260px;
  padding: 16px;
  padding-bottom: 32px;
  color: #222222;
  font-size: 14px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 20.3px;
  word-wrap: break-word;
`;

const FilterButtonContainer = styled.div`
  position: relative;
  // width: 1200px;
  // margin: 0 auto;
`;
